import * as React from 'react';
export const varoSvg = React.forwardRef(function varoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#855AC9',
      d: 'M0 .098h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5 12.098h2.06l1.257 4.143c.18.597.37 1.393.37 1.393h.025s.202-.805.37-1.393l1.245-4.143h2.006L9.7 19.995H7.651L5 12.098Zm10.028 6.027v-.67c-.243.12-.592.21-.972.295-.73.154-1.172.31-1.147.813.025.502.415.603.929.57.751-.047 1.19-.526 1.19-1.008Zm-3.824.44c0-1.24 1.044-1.616 2.272-1.77 1.113-.133 1.509-.242 1.509-.626 0-.364-.243-.606-.81-.606-.602 0-.904.251-.964.724h-1.739c.047-1.043.892-1.933 2.69-1.933.891 0 1.496.154 1.923.461.511.352.754.902.754 1.605l.006 3.715h-1.82l-.009-.626h-.022c-.349.473-.87.768-1.76.768-1.185.003-2.03-.603-2.03-1.711Zm6.206-4.126h1.728v.868h.033c.4-.661.864-.953 1.552-.953.167 0 .277.012.355.044v1.519h-.045c-1.108-.152-1.817.379-1.817 1.583v2.495H17.41V14.44Zm7.85 2.829c0-1.033-.513-1.732-1.3-1.732-.789 0-1.302.699-1.302 1.732s.513 1.72 1.301 1.72c.788 0 1.299-.687 1.302-1.72Zm-4.33 0c0-1.71 1.22-3.01 3.041-3.01 1.833 0 3.03 1.3 3.03 3.01 0 1.71-1.2 3.009-3.03 3.009-1.82 0-3.042-1.299-3.042-3.01Z',
      fill: '#fff',
    }),
  );
});
varoSvg.defaultProps = {
  width: '32',
  height: '33',
  viewBox: '0 0 32 33',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var varo = {
  category: 'brand',
  colorable: false,
  name: 'varo',
  svg: varoSvg,
};
